enum EnhancementFailureReason {
  COULD_NOT_COMPREHEND = "COULD_NOT_COMPREHEND",
  ABUSIVE_CONTENT = "ABUSIVE_CONTENT"
}

export default EnhancementFailureReason;
